module.exports = __webpack_public_path__ + "static/terra-mattress-5-d73f8b35597128156cac04b95401e6ac.png";